import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { InformesService } from 'app/services/informes.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-info-beneficiario',
  templateUrl: './info-beneficiario.component.html',
  styleUrls: ['./info-beneficiario.component.scss']
})
export class InfoBeneficiarioComponent implements OnInit {

  //DataTable
  public dtOptions;
  public tableOpt;
  @ViewChild(DataTableDirective , {static: true})
  tabla: DataTableDirective;
  public dtTrigger: Subject<void>

  constructor(private _informe: InformesService) { 
    this.dtTrigger = new Subject();
    this.dtTrigger.next();

    this.tableOpt = [];
    this.dtOptions = {
      columns: [
        {
          title: 'Teléfono',
          data: 'bentel'
        },
        {
          title: 'Dirección',
          data: 'bendir'
        },
        {
          title: 'Correo Electrónico',
          data: 'mail'
        },
        {
          title: 'Coordenadas #1',
          data: 'coordenadas_atencion'
        },
        {
          title: 'Coordenadas #2',
          data: 'coordenadas_atencion_dos'
        }
      ]
    }
  }

  @Input() doc_beneficiario: string;

  ngOnInit() {
    this._informe.InformacionBeneficiario(this.doc_beneficiario).subscribe((data:any) => {
      this.tableOpt = data.resultado;
      this.dtTrigger.next();
    })
  }

}
